import React from 'react';
import Icon from '../../../components/AppIcon';

const TabNavigation = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'overview', label: 'Aperçu', icon: 'Info' },
    { id: 'programs', label: 'Programmes', icon: 'BookOpen' },
    { id: 'admissions', label: 'Admissions', icon: 'FileText' },
    { id: 'fees', label: 'Frais', icon: 'CreditCard' },
    { id: 'careers', label: 'Débouchés', icon: 'TrendingUp' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg mb-6 overflow-hidden">
      <div className="flex overflow-x-auto scrollbar-hide">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex items-center gap-2 px-6 py-4 text-sm font-medium whitespace-nowrap transition-smooth border-b-2 ${
              activeTab === tab?.id
                ? 'text-primary border-primary bg-primary/5' :'text-muted-foreground border-transparent hover:text-foreground hover:bg-muted'
            }`}
          >
            <Icon name={tab?.icon} size={16} />
            <span>{tab?.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;